import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { trackCallClick } from '../utils/tracking';

const navLinks = [
  { to: '/', label: 'Accueil' },
  { to: '/douche-senior', label: 'Douche senior' },
  { to: '/monte-escalier', label: 'Monte-escalier' },
  { to: '/ma-prime-adapt-volets-roulants-electriques-call', label: 'Volets roulants' },
  { to: '/ma-prime-adapt', label: "Ma Prime Adapt'" },
  { to: '/nos-realisations', label: 'Nos réalisations' },
  { to: '/aides-complementaires', label: 'Aides complémentaires' },
  { to: '/verifier-eligibilite', label: 'Vérifier mon éligibilité' },
];

const Header = () => {
  const phoneNumber = "09.70.70.70.69";
  const phoneHref = "tel:+33970707069";
  const location = useLocation();

  return (
    <header className="bg-white shadow-md sticky top-0 z-40">
      <div className="container mx-auto px-4 py-4">
        {/* Desktop: Logo centré avec téléphone à droite */}
        <div className="hidden md:flex justify-between items-center">
          <div className="w-48"></div> {/* Spacer pour centrer le logo */}
          <Link to="/" className="flex-1 flex justify-center group">
            <img 
              src="/images/logo.png" 
              alt="Ma Prime Adapt' - On simplifie vos démarches d'adaptation" 
              className="h-40 object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>
          <a
            href={phoneHref}
            onClick={() => trackCallClick()}
            className="w-48 flex items-center justify-end gap-2 bg-[#033B5D] text-white px-6 py-3 rounded-lg hover:bg-[#044d75] transition-colors duration-300 font-semibold shadow-lg hover:shadow-xl"
          >
            <Phone className="h-5 w-5" />
            <span>{phoneNumber}</span>
          </a>
        </div>

        {/* Mobile: Logo centré et téléphone en dessous */}
        <div className="md:hidden flex flex-col items-center gap-4">
          <Link to="/" className="group">
            <img 
              src="/images/logo.png" 
              alt="Ma Prime Adapt' - On simplifie vos démarches d'adaptation" 
              className="h-16 object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>
          <a
            href={phoneHref}
            onClick={() => trackCallClick()}
            className="flex items-center gap-2 bg-[#033B5D] text-white px-6 py-3 rounded-lg hover:bg-[#044d75] transition-colors duration-300 font-semibold shadow-lg w-full justify-center"
          >
            <Phone className="h-5 w-5" />
            <span>{phoneNumber}</span>
          </a>
        </div>
      </div>

      {/* Navigation */}
      <nav className="bg-[#033B5D] border-t border-white/10">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center gap-1 overflow-x-auto scrollbar-hide py-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to;
              const isEligibilite = link.to === '/verifier-eligibilite';
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 ${
                    isEligibilite
                      ? 'bg-green-500 text-white hover:bg-green-600'
                      : isActive
                        ? 'text-amber-400'
                        : 'text-gray-200 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
